import { useEffect, useRef, useState } from 'react'
import api from '../api/client'

// Carrossel de banners de campanhas/incentivos (GET /incentivos/banners).
// Responsivo: usa banner_mobile_url no mobile (fallback p/ banner_url). Auto-avança; some se não houver banners.
export default function BannerCarrossel() {
  const [banners, setBanners] = useState([])
  const [i, setI] = useState(0)
  const [mobile, setMobile] = useState(typeof window !== 'undefined' && window.innerWidth < 640)
  const timer = useRef(null)

  useEffect(() => {
    api.get('/incentivos/banners').then((r) => setBanners(r.data?.data || [])).catch(() => setBanners([]))
    const onResize = () => setMobile(window.innerWidth < 640)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  useEffect(() => {
    if (banners.length <= 1) return
    timer.current = setInterval(() => setI((v) => (v + 1) % banners.length), 6000)
    return () => clearInterval(timer.current)
  }, [banners.length])

  if (!banners.length) return null
  const b = banners[i] || banners[0]
  const url = (mobile && b.banner_mobile_url) ? b.banner_mobile_url : b.banner_url
  if (!url) return null

  return (
    <div className="relative rounded-2xl overflow-hidden shadow-sm border border-gray-100 bg-white">
      <img src={url} alt={b.nome || 'Campanha'} className="w-full object-cover max-h-64 sm:max-h-80" />
      {(b.nome || b.premio) && (
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent px-4 py-3">
          <p className="text-white font-heading font-bold text-sm sm:text-base">{b.nome}</p>
          {b.subtitulo && <p className="text-white/80 text-xs">{b.subtitulo}</p>}
        </div>
      )}
      {banners.length > 1 && (
        <div className="absolute bottom-2 right-3 flex gap-1.5">
          {banners.map((_, k) => (
            <button key={k} onClick={() => setI(k)} aria-label={`Banner ${k + 1}`}
              className={`w-2 h-2 rounded-full transition ${k === i ? 'bg-white' : 'bg-white/40'}`} />
          ))}
        </div>
      )}
    </div>
  )
}
